import { render, staticRenderFns } from "./WebLogs.vue?vue&type=template&id=2dd0aeb2&scoped=true"
import script from "./WebLogs.vue?vue&type=script&lang=js"
export * from "./WebLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0aeb2",
  null
  
)

export default component.exports